/**
 * Created by Christopher.Ta on 7/15/2016.
 */
(function () {

    'use strict';

    angular
        .module('app.core')
        .factory('VehicleDetailService', [
            'API_CONFIG',
            '$http',
            '$q',
            '$cookies',
            'uuid',
            'LoggerApi',
            VehicleDetailService
        ]);

    function VehicleDetailService(API_CONFIG, $http, $q, $cookies,uuid,loggerApiService) {
        var _uuid = uuid.v4();
        var service = {};
        var ssoToken = $cookies.get('sso_token');

        service.tireCondition = undefined;

        service.getVehicleDetail = getVehicleDetail;
        service.getAnnouncements = getAnnouncements;
        service.getTireCondition = getTireCondition;
        service.getVehicleDamages = getVehicleDamages;
        service.getConditionDetail = getConditionDetail;
        service.getEquipment = getEquipment;
        service.getVehicleDisclosure = getVehicleDisclosure;
        service.getWindowSticker = getWindowSticker;
        service.getAdditionalVehicleInfo = getAdditionalVehicleInfo;
        service.getCentralizedAnnouncement = getCentralizedAnnouncement;
        service.getVdpProviders = getVdpProviders;
        service.getStatements = getStatements;

        function getVehicleDetail(vehicleId, orgId, conversationId, language) {

            loggerApiService.applicationEvent(3, "form1", "", "*","vdp","",_uuid);
            loggerApiService.applicationEventAddEvent("VehicleDetailApi",vehicleId);
            loggerApiService.applicationEventStart();
            var endpoint = 'vehicleDetails.json';
            var params = {
                vid: vehicleId,
                orgId: orgId,
                conversationId: conversationId,
                fetchServices: true,
                localeStr: language
            };
            return apiCall(endpoint, params);
        }

        function getVdpProviders(vehicleId, conversationId) {
            loggerApiService.applicationEvent(3, "form1", "", "*","vdp","",_uuid);
            loggerApiService.applicationEventAddEvent("VdpProviderApi",vehicleId);
            loggerApiService.applicationEventStart();
            var endpoint = 'vdpProviders.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId
            };
            return apiCall(endpoint, params);
        }

        function getCentralizedAnnouncement(vehicleId, conversationId, language) {
            loggerApiService.applicationEvent(3, "form1", "", "*","vdp","",_uuid);
            loggerApiService.applicationEventAddEvent("Announcement",vehicleId);
            loggerApiService.applicationEventStart();
            var endpoint = 'centralizedAnnouncements.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId,
                localeStr: language
            };
            return apiCall(endpoint, params);
        }

        function getWindowSticker(vehicleId, conversationId, language) {
            loggerApiService.applicationEvent(3, "form1", "", "*","vdp","",_uuid);
            loggerApiService.applicationEventAddEvent("windowsStickerApi",vehicleId);
            loggerApiService.applicationEventStart();
            var endpoint = 'windowStickerMessageApi.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId,
                localeStr: language
            };
            return apiCall(endpoint, params);
        }

        function getAdditionalVehicleInfo(vehicleId, conversationId, language) {
            loggerApiService.applicationEvent(3, "form1", "", "*","vdp","",_uuid);
            loggerApiService.applicationEventAddEvent("AdditionalVehicleInfoApi",vehicleId);
            loggerApiService.applicationEventStart();
            var endpoint = 'additionalVehicleInfo.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId,
                localeStr: language
            };
            return apiCall(endpoint, params);
        }

        function getAnnouncements(vehicleId, conversationId) {
            var endpoint = 'announcements.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId
            };
            return apiCall(endpoint, params);
        }

        function getEquipment(vehicleId, conversationId) {
            loggerApiService.applicationEvent(3, "form1", "", "*","vdp/Equipments","",_uuid);
            loggerApiService.applicationEventAddEvent("EquipmentApi",vehicleId);
            loggerApiService.applicationEventStart();
            var endpoint = 'equipment.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId
            };
            return apiCall(endpoint, params);
        }

        function getConditionDetail(vehicleId, conversationId, locale) {
            loggerApiService.applicationEvent(3, "form1", "", "*","vdp","",_uuid);
            loggerApiService.applicationEventAddEvent("ConditionDetailApi",vehicleId);
            loggerApiService.applicationEventStart();
            var endpoint = 'conditionDetail.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId,
                localeStr: locale
            };
            return apiCall(endpoint, params);
        }

        function getVehicleDisclosure(vehicleId, conversationId) {
            loggerApiService.applicationEvent(3, "form1", "", "*","vdp/VehicleDisclosure","",_uuid);
            loggerApiService.applicationEventAddEvent("VehicleDisclosure",vehicleId);
            loggerApiService.applicationEventStart();
            var endpoint = 'disclosures.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId
            };

            return apiCall(endpoint, params);
        }

        function getVehicleDamages(vehicleId, conversationId, locale) {
            loggerApiService.applicationEvent(3, "form1", "", "*","vdp/VehicleDamages","",_uuid);
            loggerApiService.applicationEventAddEvent("VehicleDamages",vehicleId);
            loggerApiService.applicationEventStart();
            var endpoint = 'damages.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId,
                localeStr: locale
            };
            return apiCall(endpoint, params);
        }

        function getTireCondition(vehicleId, conversationId) {
            loggerApiService.applicationEvent(3, "form1", "", "*","vdp/TireCondition","",_uuid);
            loggerApiService.applicationEventAddEvent("TireCondition",vehicleId);
            loggerApiService.applicationEventStart();
            var endpoint = 'tireCondition.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId
            };
            return apiCall(endpoint, params);
        }

        function getStatements(vehicleId, conversationId) {
            var endpoint = 'statements.json';
            var params = {
                vid: vehicleId,
                conversationId: conversationId
            };
            return apiCall(endpoint, params);
        }

        function apiCall(endpoint, params) {
            loggerApiService.applicationEventStop();
            return $http({
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'text/plain',
                    'Access-Control-Max-Age': 300,
                    'x-openlane-authentication': ssoToken

                },
                url: API_CONFIG.endpoints.IMOLA_AUCTION_ENGINE_WEB_API + endpoint,
                method: 'GET',
                params: params
            });

        }

        return service;
    }

})();


// WEBPACK FOOTER //
// ./app/core/service/VehicleDetailService.js